export default {
   api: 'http://localhost:3000',
   api_dotcom: 'https://api.iristravelgroup.com',
   pass: 'd00632e42209247297f60b5dff458f88', // iristravelGroup@123
   gallery_url: "https://iristravel.s3.us-east-2.amazonaws.com/images/"
}